import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';
moment.locale('pt-Br')

@Pipe({
    name: 'pipeAdjustData'
})
export class PipeAdjustData implements PipeTransform {
    transform(date: string): string {
        return moment(date).format('LLLL')
    }
}


// WEBPACK FOOTER //
// ./src/app/restricted/pipe/pipeAdjustData.ts